import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../Auth.css";

function Signup() {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    role: "customer",
  });
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Client-side password validation
    const hasMinLength = formData.password.length >= 8;
    const hasNumberOrSymbol = /[\d!@#$%^&*(),.?":{}|<>]/.test(
      formData.password,
    );

    if (!hasMinLength || !hasNumberOrSymbol) {
      setError(
        "Password must be at least 8 characters long and contain at least one number or special character.",
      );
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const data = await res.json();

      if (!res.ok) throw new Error(data.error || "Signup failed");

      localStorage.setItem("user", JSON.stringify(data.user));
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">Sign Up</h1>
          <p className="auth-subtitle">Create an account to get started.</p>
        </div>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-row">
            <div className="form-group">
              <label className="form-label" htmlFor="firstname">
                First Name
              </label>
              <input
                id="firstname"
                type="text"
                name="firstname"
                className="form-input"
                placeholder="Jane"
                value={formData.firstname}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="lastname">
                Last Name
              </label>
              <input
                id="lastname"
                type="text"
                name="lastname"
                className="form-input"
                placeholder="Smith"
                value={formData.lastname}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              name="email"
              className="form-input"
              placeholder="jane@example.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              name="password"
              className="form-input"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              minLength={8}
              required
            />
            <small
              style={{
                color: "#666",
                fontSize: "0.8rem",
                marginTop: "4px",
                display: "block",
              }}
            >
              Must be at least 8 characters long and contain 1 number or special
              character.
            </small>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="role">
              Register As
            </label>
            <select
              id="role"
              name="role"
              className="form-input"
              value={formData.role}
              onChange={handleChange}
            >
              <option value="customer">Customer</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <button
            type="submit"
            className="auth-submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Creating account..." : "Sign Up"}
          </button>
        </form>

        <hr className="auth-divider" />

        <div className="auth-switch-container">
          <p className="auth-switch-text">Already have an account?</p>
          <Link to="/login" className="auth-switch-btn">
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Signup;
